import React from "react";
import { Route, Routes } from "react-router-dom";
import "../index.css";
import Dashboard from "../pages/Dashboard";
import Header from '../components/Header';
import Footer from '../components/Footer';
import Profile from "../pages/Profile";
import Orders from "../pages/Orders";
import Contact from "../pages/Contact";
import Address from "../pages/Address";
import Guidance from "../pages/Guidance";
import Comment from "../pages/Comment";
import Reports from "../pages/Reports";
import Map from "../components/Map";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FinalInfo from "../pages/FinalInfo";

function Admin() {

  return (
    <div>
      <Header />
      <div className="rgc-main">
        <Routes>
          <Route path='dashboard' element={<Dashboard />}>
            <Route path=":requestId" element={<Dashboard />} />
         </Route>
        
          <Route path='report' element={<Reports />} />
          <Route path="map" element={<Map/>} />
          <Route path='profile' element={<Profile />} />
          <Route path="finalinfo" element={<FinalInfo/>} />
          <Route path='/*' element={<Orders />}/>
          <Route path='orders' element={<Orders />}/>
          <Route path='contact' element={<Contact />}/>
          <Route path='address' element={<Address />}/>
          <Route path='guidance' element={<Guidance />}/>
          <Route path='comment' element={<Comment />}/>
        </Routes>
      </div>
      <div className="rgc-toast">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          className="rgc-toast"
        />
      </div>
      <Footer />
    </div>

  );
}

export default Admin;
